module.exports = "<!-- START SECONDARY SIDEBAR MENU-->\n<div class=\"secondary-sidebar {{_extraClass}}\" [ngStyle]=\"_togglePosition\" [class.secondary-show]=\"_toggleMobileSidebar\" [class.secondary-hide]=\"!_toggleMobileSidebar\" >\n    <ng-content></ng-content>\n  </div>\n    <!-- END SECONDARY SIDEBAR MENU -->"


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/app/@hornbillfx/components/secondary-sidebar/secondary-sidebar.component.html
// module id = ../../../../../src/app/@hornbillfx/components/secondary-sidebar/secondary-sidebar.component.html
// module chunks = main